import * as Yup from "yup";
import { toast } from "react-toastify";
import FormDefault from "../../components/Forms/FormDefault";
import { Button } from "../../components/Buttons";
import { Circle } from "../../components/Animation";
import { H2 } from "../../components/Text";
import { validateArray } from "../../utils/validate";
import { requestAuth } from "../../components/services/RequestService";
import ListInCharge from "../ModalsCompany/ListInCharge";
import { useState } from "react";
import { Request } from "../../hooks/Request";
import dayjs from "dayjs";
import { useModal } from "../../contexts/ModalContext";

const NewProcedure = (props) => {
  const { reload, onClose, openModal } = props;

  // const { openModal: openModal2 } = useModal()
  const { openModal: openModalIncharge, onClose: onCloseIncharge } = useModal()
  function handleInCharge(values) {
    openModalIncharge(<ManageInCharge values={values} onCloseIncharge={onCloseIncharge} {...props} />);
  }

  return (
    <div>
      <FormDefault
        tittle="Aperturar nueva carpeta"
        fields={[
          {
            label: "Compañia",
            name: "CompanyId",
            typeInput: "select",
            urlApi: "/company/getallcompanies",
            value: "id",
            labelOption: "razonSocial",
          },
          {
            label: "Tipo de procedimiento",
            name: "ProcedureTypeId",
            typeInput: "select",
            urlApi: "/procedureType",
            value: "id",
            labelOption: "name",
          },
          {
            label: "Sucursal",
            name: "city",
            typeInput: "select",
            options: [
              {
                label: "La Paz",
                value: "LP",
              },
              {
                label: "Santa Cruz",
                value: "SC",
              },
              {
                label: "Tarija",
                value: "TJ",
              }
            ],
          },
          {
            label: "Gestión",
            name: "year",
            typeInput: "select",
            options: [
              {
                label: "2024",
                value: "2024",
              },
              {
                label: "2025",
                value: "2025",
              },
              {
                label: "2026",
                value: "2026",
              },
            ],
          },
        ]}
        initialValues={{
          CompanyId: "",
          ProcedureTypeId: 1,
          city: "LP",
          year: dayjs().format("YYYY"),
        }}
        validationSchema={Yup.object().shape({
          CompanyId: Yup.string().required("Este campo es obligatorio"),
          ProcedureTypeId: Yup.string().required("Este campo es obligatorio"),
        })}
        onSubmit={handleInCharge}
        buttonName="Guardar"
      />
    </div>
  );
};

const ManageInCharge = (props) => {
  const { reload, onClose, values, onCloseIncharge } = props;
  const { data, loading, call } = Request({
    urlApi: `/company/${values.CompanyId}/inChargeCompany`,
  });
  const [load, setload] = useState(false);
  async function handleRegister() {
    setload(true);
    await requestAuth("post", `/procedure`, {
      ...values,
      city: values.city === "LP" ? "" : values.city,
    })
      .then(() => {
        setload(false);
        reload();
        onClose();
        onCloseIncharge && onCloseIncharge()
        toast.success("Trámite agregado correctamente!!!");
      })
      .catch(() => {
        setload(false);
        toast.error("Se ha producido un error al crear el Proceso");
      });
  }
  return (
    <div>
      <H2>Encargados del Cliente</H2>
      <ListInCharge company={{ id: values.CompanyId }} reloadList={call} />
      {load && loading ? (
        <Circle />
      ) : (
        <Button
          onClick={handleRegister}
          disabled={!validateArray(data)}
          className={`py-4 w-full`}
        >
          Registrar
        </Button>
      )}
    </div>
  );
};

export default NewProcedure;
